document.addEventListener("DOMContentLoaded", function () {

    document.querySelectorAll('.timer-outer').forEach(function(element) {
        var date = element.querySelector("#date").innerText;
        console.log(date);

        var countdownDate = new Date(date).getTime();

        function formatTime(num) {
            if (num < 10) {
                return `0${num}`;
            }
            return `${num}`;
        }
        function updateCountdown() {
            var nowAus = new Date(new Date().toLocaleString("en-US", {timeZone: "Australia/Brisbane"})).getTime();
            
            var timeLeft = countdownDate - nowAus;
            
            var days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
            var hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

            element.querySelector("#days").textContent = formatTime(days);
            element.querySelector("#hours").textContent = formatTime(hours);
            element.querySelector("#minutes").textContent = formatTime(minutes);
            element.querySelector("#seconds").textContent = formatTime(seconds);
        }
        
        updateCountdown();
        setInterval(updateCountdown, 1000);
    });

  });
    